import { useEffect, useState } from "react";
import { Box, IconButton, LinearProgress, Typography } from "@mui/material";
import { facts } from "src/mockup/Facts";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";
import styles from "../../content/pages/homepage.module.css";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

function LoaderFacts({
  onClose,
  goBack,
  showExpandToggle = false,
  isExpanded,
  onToggleExpand,
}: {
  onClose: () => void;
  goBack?: () => void;
  showExpandToggle?: boolean;
  isExpanded?: boolean;
  onToggleExpand?: () => void;
}) {
  const [factIndex, setFactIndex] = useState(0);
  // State to indicate if a new fact is rendered
  const [showingNewFact, setShowingNewFact] = useState(true);

  useEffect(() => {
    // Creates an initial random index before rendering the first fact
    const randomIndex = Math.floor(Math.random() * facts.length);
    setFactIndex(randomIndex);
    // Update the fact index every 5 seconds
    const interval = setInterval(() => {
      // Generates a random index to choose random fact
      const randomIndex = Math.floor(Math.random() * facts.length);
      setFactIndex(randomIndex);
      setShowingNewFact(true); // New fact is rendered
    }, 6000);
    return () => clearInterval(interval); // Clear the interval when the component unmounts
  }, []);

  return (
    <>
      <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center" p={1} bgcolor={`${PureLightThemeCaaS.colors.alpha.black[100]}`}>
        <Box display="flex" flexDirection="row" justifyContent="flex-end" alignItems="center">
          {/* <IconButton aria-label="back" onClick={goBack}> */}
          <IconButton
            aria-hidden
            tabIndex={-1}
            disabled
            sx={{ visibility: "hidden", pointerEvents: "none" }}
          >
            <ArrowBackIcon sx={{ color: `${PureLightThemeCaaS.colors.alpha.black[100]}` }} />
          </IconButton>
        </Box>
        <Typography variant="h4" color={`${PureLightThemeCaaS.colors.alpha.white[100]}`} textAlign={"center"} className={styles.tradeTeam}>
          {/* Please wait...*/}
          {/* Getting League Data... */}
        </Typography>
        <Box display="flex" flexDirection="row" justifyContent="flex-end" alignItems="center">
          {showExpandToggle && onToggleExpand && (
            <IconButton aria-label="toggle-expand" onClick={onToggleExpand}>
              {isExpanded ? (
                <KeyboardArrowDownIcon sx={{ color: `${PureLightThemeCaaS.colors.alpha.white[100]}` }} />
              ) : (
                <KeyboardArrowUpIcon sx={{ color: `${PureLightThemeCaaS.colors.alpha.white[100]}` }} />
              )}
            </IconButton>
          )}
          <IconButton aria-label="close" onClick={onClose}>
            <CloseIcon sx={{ color: `${PureLightThemeCaaS.colors.alpha.white[100]}` }} />
          </IconButton>
        </Box>
      </Box>

      <Box sx={{ pl: 2, pr: 2 }} bgcolor={`${PureLightThemeCaaS.colors.alpha.black[100]}`}>
        <LinearProgress color="inherit" sx={{ height: "4px", color: `#ff672d` }} />
      </Box>

      {/* //hide facts on purpose*/}
      {/* <Box
        sx={{ p: 1, pt: 0, pb: 0, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "120px" }}
        bgcolor={`${PureLightThemeCaaS.colors.alpha.black[100]}`}
      >
        <Typography
          variant="h6"
          className={`${styles.loaderText} ${showingNewFact ? styles.fadeIn : styles.fadeOut}`}
          onAnimationEnd={() => setShowingNewFact(false)}
          color={`${PureLightThemeCaaS.colors.alpha.white[100]}`}
          textAlign="center"
          p={4}
        >
          {facts[factIndex].fact}
        </Typography>
      </Box> */}
    </>
  );
}

export default LoaderFacts;
